import { AllTypeFormatter } from '_legacy/components/grid/formatters/TypeFormatter';
import store from 'store';

const TypeKeyCreator = ({ value, defaultValue }) => {
    const datasetId = store.getState().user.group.datasetId;
    return AllTypeFormatter(value, datasetId);
};

export default TypeKeyCreator;
